import {MINOR_SECTIONS} from './constants';

const VEGAN_BINARY      = 0b00000000111111000111000001010000;
const VEGETARIAN_BINARY = 0b00000000111111000000000001000000;
const GLUTEN_BINARY     = 0b00000000000000000000110000000000;
const PALEO_BINARY      = 0b00010011000000110110111000100001;
const KETO_BINARY       = 0b00100000000000000000000000000000;
const FODMAP_BINARY     = 0b01000000000000000000000000000000;

const BINARY_LOOKUP = {
    "Vegan": VEGAN_BINARY,
    "Vegetarian": VEGETARIAN_BINARY,
    "Gluten-Free": GLUTEN_BINARY,
    "Paleo": PALEO_BINARY,
    "Keto": KETO_BINARY,
    "Fodmap": FODMAP_BINARY
}

const THRESHOLD_DESCRIPTION_SIZE = 100;
const MIN_FLAGGED_ALLERGENS = 3
const MINOR_SECTION_WEIGHT = .75;
const MAJOR_SECTION_WEIGHT = 1;


const DIET_NAMES = ["Vegan", "Vegetarian", "Gluten-Free", "Paleo", "Keto", "Fodmap"];

/**
 * Determines if item contains ingredients not allowed in 
 * a particular diet or not
 * @param itemBinary : binary representation of item
 * @param itemModifiable : modifiable elements of item
 * @param diet : name of diet
 * @return false if item contains elements not suitable for that diet
 */
const containsDiet = (itemBinary, itemModifiable, diet) => {
        if (!itemBinary) return true;

        if (itemBinary && ((itemBinary & BINARY_LOOKUP[diet]) == 0))
            return true;

        if (!itemModifiable) return false;
        let dietDifference = itemBinary - (itemBinary & itemModifiable);
        if ((BINARY_LOOKUP[diet] & dietDifference) == 0)
            return true;

        return false;
    }

/**
 * Determines if an item is a major item or not
 * @param itemSection
 * @param itemBinary
 * @param itemModifiable
 * @return true if major item, false otherwise
 */
const isMajorItem = (itemSection, itemDescription, itemBinary, itemModifiable) => {
    if(itemSection && itemSection in MINOR_SECTIONS) 
        return true;
    if(itemDescription && itemDescription.length > THRESHOLD_DESCRIPTION_SIZE) 
        return true;

    let flaggedBits = itemBinary ? itemBinary.toString(2).split(1) : 0;
    let modifiableBits = itemModifiable ? itemModifiable.toString(2).split(1) : 0;
    return (Math.max(flaggedBits, modifiableBits) > MIN_FLAGGED_ALLERGENS);
}   


const performAudit = (items) => {
        //Initial weights
        let auditResult = {
            "Vegan": 1*items.length/30,
            "Vegetarian": 0*items.length/30,
            "Gluten-Free": 3*items.length/30,
            "Paleo": 6*items.length/30,
            "Keto": 5*items.length/30,
            "Fodmap": 6*items.length/30
        }
        
        let auditTotal = 0;
    
        for(let i = 0; i<items.length; i++){

            let majorItem = isMajorItem(items[i].section, items[i].description,
                items[i].score, items[i].modifiableVector);
                
            if(majorItem) auditTotal += MAJOR_SECTION_WEIGHT;
            else auditTotal += MINOR_SECTION_WEIGHT;

            for(let dietIndex = 0; dietIndex<DIET_NAMES.length; dietIndex++){
                let diet = DIET_NAMES[dietIndex];
                
                if(containsDiet(items[i].score, items[i].modifiableVector, diet)){
                    if(majorItem) auditResult[diet] += MAJOR_SECTION_WEIGHT;
                    else {
                        auditResult[diet] += MINOR_SECTION_WEIGHT;
                    }
                }
            }
        }
        
        for(let dietIndex = 0; dietIndex<DIET_NAMES.length; dietIndex++){
            let diet = DIET_NAMES[dietIndex];
            let score = (auditResult[diet]/auditTotal*10).toFixed(2);
            if(score > 10) score = 10;
            auditResult[diet] = score;
        }
        return auditResult;
    }

module.exports = {
    containsDiet,
    performAudit
}



// WEBPACK FOOTER //
// ./src/views/Analytics/audit.js